<div [ngClass]="{'open': opened}" class="settings-box">
  <div class="toggle-setting">
    <i [ngClass]="{'fa-spin': opened}" (click)="toggleBoxSetting()" class="fa fa-cog"></i>
  </div>
  <div class="setting-container">
    <div class="option-box">
      <h4>Colors</h4>
      <ul class="colors-list">
        <li [ngClass]="{'active': colorSelected===c}" (click)="getColorSelected(c)"
            *ngFor="let c of colors"
            class=""></li>
      </ul>
    </div>
  </div>
</div>
